import axios from 'axios'
import Vue from 'vue'

export const actions = {
  async getMemberProfileForSet ({ commit, state, rootGetters }, check) {
    try {
      const shopId = rootGetters['shopStore/GET_SHOPID']
      const profile = rootGetters['lineStore/getLiffProfile']
      // Use centralized DNS_IP from Vue.prototype
      // Fallback to production URL if not set yet
      this.url = Vue.prototype.$DNS_IP || 'https://api-beloyalty-productions.betaskthai.tech/'
      const result = await axios.get(`${this.url}/memberCard/line/get`, { headers: { lineUserId: profile.userId, memberId: profile.memberId, shopId: shopId } })
      if (result.data.length > 0) {
        this.member = result.data[0]
        commit('SET_MEMBERINFO', this.member)
        // console.log(this.member.tel)
        // const resultAfterCheckQr = await axios.post(`${this.url}/POSapi/checkQrcode`, {
        //   shopId: this.member.shopId,
        //   tel: this.member.tel
        // })
        // console.log('come here', resultAfterCheckQr)
        // if (resultAfterCheckQr.data[0].status === true) {
        //   this.member = resultAfterCheckQr.data[0].response
        //   commit('SET_MEMBERINFO', this.member)
        // } else if (resultAfterCheckQr.data[0].status === false) {
        //   commit('SET_MEMBERINFO', this.member)
        // }
      } else {
        commit('SET_MEMBERINFO', null)
      }
    } catch (error) {
      console.error('getMemberProfileja error', error.message)
    }
  },
  async getMemberProfile ({ commit, state, rootGetters }, check) {
    try {
      const shopId = rootGetters['shopStore/GET_SHOPID']
      const profile = rootGetters['lineStore/getLiffProfile']
      // Use centralized DNS_IP from Vue.prototype
      this.url = Vue.prototype.$DNS_IP || 'https://api-beloyalty-productions.betaskthai.tech/'
      const result = await axios.get(`${this.url}/memberCard/line/get`, { headers: { lineUserId: profile.userId, memberId: profile.memberId, shopId: shopId } })
      if (result.data.length > 0) {
        this.member = result.data[0]
        const resultAfterCheckQr = await axios.post(`${this.url}/POSapi/checkQrcode`, {
          shopId: this.member.shopId,
          tel: this.member.tel
        })
        if (resultAfterCheckQr.data[0].status === true) {
          this.member = resultAfterCheckQr.data[0].response
          commit('SET_MEMBERINFO', this.member)
        } else if (resultAfterCheckQr.data[0].status === false) {
          commit('SET_MEMBERINFO', this.member)
        }
      } else {
        commit('SET_MEMBERINFO', null)
      }
    } catch (error) {
      console.error('getMemberProfileja error', error.message)
      // Ensure member state is consistent even when API fails
      commit('SET_MEMBERINFO', null)
    }
  },
  async getMemberProfileByMemberId ({ commit, state, rootGetters }, check) {
    try {
      const shopId = rootGetters['shopStore/GET_SHOPID']
      const profile = rootGetters['lineStore/getLiffProfile']
      // Use centralized DNS_IP from Vue.prototype
      this.url = Vue.prototype.$DNS_IP || 'https://api-beloyalty-productions.betaskthai.tech/'

      const result = await axios.get(`${this.url}/memberCard/line/get`, { headers: { memberId: profile.memberId, tel: profile.tel, shopId: shopId } })
      if (result.data.length > 0) {
        this.member = result.data[0]
        const resultAfterCheckQr = await axios.post(`${this.url}/POSapi/checkQrcode`, {
          shopId: this.member.shopId,
          tel: this.member.tel
        })
        if (resultAfterCheckQr.data[0].status === true) {
          this.member = resultAfterCheckQr.data[0].response
          commit('SET_MEMBERINFO', this.member)
        } else if (resultAfterCheckQr.data[0].status === false) {
          commit('SET_MEMBERINFO', this.member)
        }
      } else {
        commit('SET_MEMBERINFO', null)
      }
    } catch (error) {
      console.error('getMemberProfile error', error.message)
    }
  },
  async setNullMemberInfo ({ commit, state, rootGetters }) {
    commit('SET_MEMBERINFO', null)
  }
}



// WEBPACK FOOTER //
// ./src/store/member/actions.js